// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `bai-product-details p {
  font-size: 14px;
}
bai-product-details p.medium {
  font-size: 14px;
}

bai-product-details .title {
  padding-bottom: 0.5em;
}

bai-product-details .description {
  padding-bottom: 2.5em;
}
`, "",{"version":3,"sources":["webpack://./apps/lms/src/css/catalog/baiProductDetails.css"],"names":[],"mappings":"AAAA;EACE,eAAe;AACjB;AACA;EACE,eAAe;AACjB;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,qBAAqB;AACvB","sourcesContent":["bai-product-details p {\n  font-size: 14px;\n}\nbai-product-details p.medium {\n  font-size: 14px;\n}\n\nbai-product-details .title {\n  padding-bottom: 0.5em;\n}\n\nbai-product-details .description {\n  padding-bottom: 2.5em;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
